import SimpleBar from 'simplebar';
import LayoutHelper from "../Helper/Layout";
import AnimationHelper from "../Helper/Animation";
import BaseComponent from './BaseComponent';
import App from "../Core/App";

export default class SubnavComponent extends BaseComponent {
    constructor(id) {
        super();

        if ($(id).length === 0) {
            this._exists = false;
            return;
        }

        let app = App.getInstance(),
            em  = app.getEventManager();

        this._exists        = true;
        this._id            = id; // Unique jQuery element selector

        this.scrollbar      = new SimpleBar($(this._id + ' .blb-box-content-wrapper')[0], {autoHide: false});

        // We need to make sure that all box animations have ended before we set our breakpoints
        em.on('doneInitialBoxAnimations', function() {
            this.setCollapseTrigger();
            this.setStickyTrigger();
            // Run a first check if our navigation should enter sticky mode
            this._onScroll();
        }.bind(this));
    }

    setCollapseTrigger() {
        if( !this._exists ) return;

        $('div[class*="blb-box-container"]').first().children('.blb-box').each((i,el) => {
            if($(el).css('grid-column-start') === '2' && !$(el).hasClass('blb-subnav')) {
                this._collapseTrigger = $(el);
                return;
            }
        });

        if($('.blb-box-absolute.index_0').length > 0) {
            this._collapseTrigger = $('.blb-box-absolute.index_0');
        }
    }

    setStickyTrigger() {
        if( !this._exists ) return;

        let bodyRect = document.body.getBoundingClientRect(),
            elemRect = $(this._id)[0].getBoundingClientRect();

        this._topBorder = elemRect.top - bodyRect.top;
    }

    exists() {
        return this._exists;
    }

    getId() {
        return this._id;
    }

    _onScroll() {
        let el = $(this._id),
            $navwrap = $('.blb-nav-wrapper').first();

        // Is our subnavigation sticky and are we in collapsed mode? If so, expand it
        if( $(window).scrollTop() >= this._topBorder && !el.hasClass('sticky') && LayoutHelper.getCurrentLayout() == 'mobile' ) {
            // Start sticky mode
            el.addClass('sticky');
            $navwrap.addClass('sticky-mobile');
            $navwrap.css('top', el.find('.blb-box-header')[0].scrollHeight);
        }
        else if( $(window).scrollTop() < this._topBorder && el.hasClass('sticky') ) {
            // End sticky mode
            el.removeClass('sticky');
            $navwrap.removeClass('sticky-mobile');
        }

        // If an expanded subnav scrolls over the box below it -> collapse subnav
        if( typeof this._collapseTrigger !== 'undefined' ) {
            if( LayoutHelper.getCurrentLayout() != 'mobile' &&
                !el.hasClass('collapsed') &&
                !el.hasClass('force-active') && // Workaround for force open on overlap, see Box.js -> _onToggleClick()
                LayoutHelper.overlaps(el[0], this._collapseTrigger[0]) ) {

               AnimationHelper.toggleBox(el);
            } else if(window.scrollY == 0 && el.hasClass('collapsed') && !LayoutHelper.isCollapsedView()){
                AnimationHelper.toggleBox(el);
            }
        }
    }

    _onResize() {
        if ( !$(this._id).hasClass('sticky') && this.exists() && LayoutHelper.getCurrentLayout() == 'mobile' ) {
            this.setStickyTrigger();
        }

        // Remove possible leftover inline style from jQuery nav dropdown animate
        if( LayoutHelper.getCurrentLayout() != 'mobile' ) {
            $('.blb-nav-wrapper').removeClass('sticky-mobile');
            $(this._id).removeClass('sticky');
            $('.blb-nav-toggle-btn').removeClass('active');
        }

        this.exists() && this.scrollbar.recalculate();
    }
}